import { useDeviceType } from './useDeviceType';
import { useMediaBreakpoints } from './useMediaBreakpoints';
export var useMediaBreakpointsWithSSR = function useMediaBreakpointsWithSSR(props, serverValue) {
  var _useDeviceType = useDeviceType(),
      isServer = _useDeviceType.isServer;

  var value = useMediaBreakpoints(props);
  return isServer ? serverValue : value;
};